<template>
  <section class="page-user-course-description mt-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-lg-7 m-auto mb-5">
          <what-will-i-learn :items="goals"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 m-auto">
          <div class="panel-card">
            <header>
              <h3 class="text-right font-18">توضیحات دوره :</h3>
            </header>
            <article>
              <p class="font-14 text-right" v-html="courseDetail.course_description"></p>
            </article>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 m-auto">
          <instructor/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import whatWillILearn from 'cp/min-component/what-will-i-learn.vue'
import requirements from 'cp/requirements.vue'
import instructor from 'cp/instructor.vue'
export default {
  name: 'page-user-course-description',
  components: {
    whatWillILearn,
    requirements,
    instructor
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    courseId() {
      return this.$route.params.id
    },
    courseDetail() {
      return this.$store.state.courses.courseDetail
    },
    goals() {
      return this.$store.state.courses.goals
    }

  }
}
</script>
<style lang="less">
@import (reference) "../../../../../../../assets/css/variable.less";

.page-user-course-description {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/course-description/index.vue